import Big from 'big.js'
import { Divider, FlexColumn } from 'components/base'
import { CurrencyMetadata } from 'indices-list'
import React, { useEffect } from 'react'
import { GLOBAL_COLORS } from 'theme'
import { valueToCurrencyFormat } from 'utils'
import { CurrencyValue, CurrencyValueContainer, MaxButton, SectionTitle } from '../../../styles'
import { AssetsSelect } from './asset-selector'
import { Input, InputBox } from './styled'
import { InputAssetType } from 'components/widgets/invest-component/storage/interface'

export interface InputProps {
  whiteList: CurrencyMetadata[]
  input: InputAssetType
  amount: string
  onInputChange: (amount: string) => void
  onAssetChange: (asset: CurrencyMetadata) => void
}

export const InputComponent: React.FC<InputProps> = ({
  whiteList,
  input,
  amount,
  onInputChange,
  onAssetChange,
}) => {
  const [dropdownOpened, setDropdownOpened] = React.useState<boolean>(false)

  const onChangeAsset = (asset: CurrencyMetadata) => {
    onAssetChange(asset)
  }

  useEffect(() => {
    if (input.amount.gt(0)) {
      onInputChange(input.amount.toString())
    }
  }, [input.asset.decimals])

  return (
    <FlexColumn>
      <SectionTitle>You pay</SectionTitle>
      <InputBox>
        <AssetsSelect
          list={whiteList}
          onChange={setDropdownOpened}
          isOpened={dropdownOpened}
          selectedAsset={input.asset}
          selectAsset={onChangeAsset}
        />
        <FlexColumn>
          <Input
            type="text"
            value={amount}
            onChange={({ target }) => onInputChange(target.value)}
            autoComplete="off"
            autoCorrect="off"
            inputMode="decimal"
            pattern={`^[0-9]*[.,]?[0-9]{0,${input.asset.decimals}}$`}
            placeholder="0.00"
            minLength={1}
            maxLength={100}
            spellCheck="false"
          />
          <CurrencyValueContainer>
            <CurrencyValue>
              {valueToCurrencyFormat(input.value ?? Big(0)) ?? 'loading'}
            </CurrencyValue>
            <MaxButton onClick={() => onInputChange(input.adjustedAmount.toString())}>
              Max
            </MaxButton>
          </CurrencyValueContainer>
        </FlexColumn>
      </InputBox>
      <Divider size={1} color={GLOBAL_COLORS.footerBorder} />
    </FlexColumn>
  )
}
